/*
 * decaffeinate suggestions:
 * DS001: Remove Babel/TypeScript constructor workaround
 * DS102: Remove unnecessary code created because of implicit returns
 * DS104: Avoid inline assignments
 * DS203: Remove `|| {}` from converted for-own loops
 * DS204: Change includes calls to have a more natural evaluation order
 * DS205: Consider reworking code to avoid use of IIFEs
 * DS206: Consider reworking classes to avoid initClass
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
import ScriptView from "./ScriptView";
import qs from "query_string";

let RunnerUi;

export default (RunnerUi = (function() {
    RunnerUi = class RunnerUi extends Backbone.Marionette.Layout {
        constructor(...args) {
            super(...args);
            this.initialize = this.initialize.bind(this);
        }

        static initClass() {
            this.prototype.template = require("./templates/runner_ui");
            this.prototype.regions =
                {script: ".script"};
    
            this.prototype.ui = {
                resetBtn: ".reset-button",
                pauseBtn: ".pause-button",
                playBtn: ".play-button",
                stepBtn: ".step-button",
                editBtn: ".edit-button",
                trashBtn: ".trash-button",
                runBtn: ".run-button",
                targetsTgl: ".targets-toggle",
                updateTargetsBtn: ".targets-update-button"
            };
    
            this.prototype.events = {
                "click .reset-button"() {
                    const params = qs.parse();
                    if ((params.ITautoPlay == null)) {
                        params.ITautoPlay = false;
                    }
                    return this._reload(params);
                },
                "click .pause-button"() {
                    return this.interpreter.pause();
                },
                "click .play-button"() {
                    return this.interpreter.play();
                },
                "click .step-button"() {
                    return this.interpreter.step();
                },
                "click .edit-button"() {
                    this.model.set("scriptState", "edit");
                    return this.render();
                },
                "click .trash-button"() {
                    if (window.confirm("Are you sure you'd like to discard your changes?")) {
                        const params = qs.parse();
                        delete params.ITautoPlay;
                        return this._reload(params);
                    }
                },
                "click .run-button"() {
                    const params = qs.parse();
                    params.IT = this.scriptModel.get("script");
                    delete params.ITautoPlay;
                    return this._reload(params);
                },
                "click .targets-toggle"() {
                    return this.model.set({showTargets: !this.model.get("showTargets")});
                },
                "click .targets-update-button"() {
                    return this.model.trigger("change:showTargets", this.model, true);
                }
            };
             // ghetto!!
        }

        _reload(params) {
            params.ITr = Math.random().toString().substr(2);
            return window.location.search = qs.serialize(params);
        }

        initialize() {
            this.interpreter = this.model.get("interpreter");
            this.scriptModel = new Backbone.Model({
                script: this.model.get("script"),
                view: this.model.get("scriptState") === "edit" ? "editor" : "lines"
            });
            this.lines = new Backbone.Collection((this.model.get("script").replace(/\n\s*$/, "").split("\n").map((l) =>
                new Backbone.Model({
                    text: l
                }))
            ));
            this.listenTo(this.model, "change:scriptState", (m, v) => this.scriptModel.set({view: v === "edit" ? "editor" : "lines"}));
            this.interpreter.on("all", function(event, atom, payload, ts) {
                if ((arguments.length !== 4) || !(atom != null ? atom.line : undefined)) {
                    return;
                }
                const line = this.lines.at(atom.line - 1);
                if (event.indexOf("error:") === 0) {
                    this.scriptModel.set({activeLine: atom.line});
                    return line.set({clazz: "error", error: payload, atom});
                } else {
                    if (event.indexOf(":start") > 0) {
                        this.scriptModel.set({activeLine: atom.line});
                        return line.set({clazz: "active"});
                    } else if (event.indexOf(":done") > 0) {
                        return line.set({clazz: "done"});
                    }
                }
            }.bind(this))
            .on("parsed", es => {
                if (es.length === 0) {
                    for (const c of this.interpreter.commands) {
                        this.lines.at(c.line - 1).set({cmd: c});
                    }
                    return (() => {
                        const result = [];
                        for (const m of this.lines.models) {
                            if (!m.has("cmd")) {
                                result.push(m.set({clazz: "comment"}));
                            } else {
                                result.push(undefined);
                            }
                        }
                        return result;
                    })();
                }
            })
            .on("start", p => p.always(() => this.model.set("scriptMode", "done")));
            return this.listenTo(this.model, "change", this.render);
        }

        onRender() {
            this.script.show(new ScriptView({
                model: this.scriptModel,
                collection: this.lines
            }));
            const enabled = [];
            switch (this.model.get("scriptState")) {
                case "pending":
                    enabled.push("edit");
                    break;
                case "start":
                    enabled.push("reset");
                    enabled.push("step");
                    enabled.push("play");
                    enabled.push("edit");
                    break;
                case "play":
                    enabled.push("reset");
                    enabled.push("pause");
                    break;
                case "pause":
                    enabled.push("reset");
                    enabled.push("step");
                    enabled.push("play");
                    enabled.push("edit");
                    break;
                case "success": case "error":
                    enabled.push("reset");
                    enabled.push("edit");
                    break;
                case "edit":
                    enabled.push("trash");
                    enabled.push("run");
                    break;
                default:
            }
            if (this.model.get("showTargets")) {
                this.ui.targetsTgl.addClass("active");
                enabled.push("updateTargets");
            } else {
                this.ui.targetsTgl.removeClass("active");
            }
            return (() => {
                const result = [];
                for (const n of Object.keys(this.ui || {})) {
                    const b = this.ui[n];
                    if (n.substr(n.length - 3) === "Btn") {
                        const needle = n.substr(0, n.length - 3);
                        if (enabled.includes(needle)) {
                            result.push(b.removeAttr("disabled"));
                        } else {
                            result.push(b.attr("disabled", "disabled"));
                        }
                    } else {
                        result.push(undefined);
                    }
                }
                return result;
            })();
        }
    };
    RunnerUi.initClass();
    return RunnerUi;
})());



// WEBPACK FOOTER //
// ./test/it/lib/RunnerUi.js